import Splide from '@splidejs/splide';
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';

function carouselMedia() {
    const carouselMediaCards = document.querySelectorAll('.splide--carousel_media');

    carouselMediaCards.forEach((item) => {

        const splide = new Splide(item, {
            drag: true,
            autoWidth: false,
            pagination: true,
            arrows: false,
            type: 'loop',
            focus: 'center',
            perPage: 1,
            perMove: 1,
            padding: { left: '15vw', right: '15vw' },
            gap: 60,
            speed: 600, // Velocidad de transición consistente
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)', // Easing suave
            rewind: false, // Evita recalculo al volver
            waitForTransition: false, // NO espera a que termine la transición
            updateOnMove: false, // NO actualiza durante movimiento
            trimSpace: false, // NO recorta espacio extra
            breakpoints: {
                1440: {
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 300, right: 300 },
                    gap: 15
                },
                1024: {
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 150, right: 150 },
                    gap: 15
                },
                768: {
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 80, right: 80 },
                    gap: 15
                },
                576: {
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 30, right: 30 },
                    gap: 15
                }
            }
        });

        splide.mount();

        // Inicializar lightGallery para los videos dentro de este splide
        const videoLinks = item.querySelectorAll('.card__carousel-media__video-btn');
        videoLinks.forEach((link) => {
            lightGallery(link, {
                selector: '.card__carousel-media__video-link',
                plugins: [lgVideo],
                speed: 500,
                licenseKey: '0000-0000-000-0000',
                download: false,
            });
        });
    });
}

export default carouselMedia;